<template>
  <div
    class="flex flex-row px-3 rounded-lg cursor-pointer slide-card bg-base-0"
    @click="makeSlideActive()"
  >
    <div
      class="slide-card __image-container"
      :style="{ 'background-color': slide.baseColour, 'color': slide.textColour }"
    >
      <div v-if="!isLoading">
        <!-- make sure img comes first
        before slide-type-icon so that img's opacity doesn't affect text -->
        <img
          class="object-cover w-full h-full rounded slide-card __image"
          :style="{
            'opacity': slide.visibility / 100,
          }"
          alt=""
          v-show="slide.thumbnail && isThumbnailLoaded"
          :src="slide.thumbnail"
          @load="onThumbnailLoad"
        >
        <slide-type-icon
          class="absolute"
          :class="slide.type"
          :slide-type="slide.type"
          :child-type="slide.slideType"
          :textColour="slide.textColour"
        />
        <div
          class="w-full h-full rounded slide-card __image --no-thumbnail"
          v-show="!(slide.thumbnail && isThumbnailLoaded)"
        />
      </div>
      <div
        v-else
        class="slide-card __image-container"
      >
        <aha-skeleton-loader
          width="115px"
          height="65px"
          class="object-cover w-full h-full rounded slide-card __image"
        />
      </div>
    </div>
    <div class="slide-card __content">
      <p class="mb-2 slide-card __title" :class="{'opacity-0': slide.type === 'freestyle'}">
        <span v-if="!isLoading">
          {{ slide.title }}
        </span>
        <aha-skeleton-loader
          v-else
          width="90%"
          height="16px"
        />
      </p>
      <div class="slide-card __data">
        <slot v-if="!isLoading" />
        <div
          class="flex flex-col w-full"
          v-else
        >
          <aha-skeleton-loader
            class="mb-2"
            width="60%"
            height="12px"
          />
          <aha-skeleton-loader
            width="40%"
            height="12px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components

import { mapState } from 'vuex'
import SlideTypeIcon from '@/components-v2/common/slide-type-icon/SlideTypeIcon.vue'
import EventBus from '@/eventBus'

export default {
  components: {
    SlideTypeIcon,
  },
  props: {
    slide: {
      type: Object,
      default: () => ({}),
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isThumbnailLoaded: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    onThumbnailLoad() {
      this.isThumbnailLoaded = true
    },

    makeSlideActive() {
      const slideIndex = this.presentation.slides.findIndex((s) => s.id === this.slide.id)
      EventBus.$emit('makeSlideActive', this.presentation.slides[slideIndex], this.slide.deleted, 'report')
    },
  },
}
</script>

<style lang="scss" scoped>
$card-width: 115px;
$thumbnail-ratio: calc(16 / 9);
.slide-card {
  .aha-slide-type-icon {
    top: 6px;

    &.leaderboard {
      top: 24px;
    }
  }

  &.__title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    overflow: hidden;
    @apply text-md14-h18;
  }

  &.__image {
    width: $card-width;
    height: calc(#{$card-width} / #{$thumbnail-ratio});

    &.--no-thumbnail {
      box-shadow: 0 0 1px 1px #b4bccf;
    }
  }

  &.__image-container {
    @apply relative flex-shrink-0 mr-3 rounded;
  }

  &.__data {
    @apply flex items-center;
  }

  &.__content {
    @apply flex flex-col justify-between w-full;
  }
}
</style>
